var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"error-messages":_vm.phoneErrors,"label":_vm.label,"readonly":_vm.readOnly,"required":_vm.required},on:{"keyup":_vm.emitPhone,"input":function($event){return _vm.$v.phone.$touch()},"blur":function($event){return _vm.$v.phone.$touch()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }